import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// Import Font Awesome
import '@fortawesome/fontawesome-free/css/all.min.css'

const app = createApp(App)
  .use(store)
  .use(router)

// Apply initial theme from store
const initialTheme = store.getters.currentTheme
document.body.setAttribute('data-theme', initialTheme)

app.mount('#app')
